// extracted by mini-css-extract-plugin
export default {"tooltip":"XP-z","arrow":"YP-z"};